import { Component, Inject, OnInit } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-home-add-new-social-field-popup',
  templateUrl: './home-add-new-social-field-popup.component.html',
  styleUrls: ['./home-add-new-social-field-popup.component.scss'],
})
export class HomeAddNewSocialFieldPopupComponent  implements OnInit {
  loggedInUserCompanyID:any;
  loggedInUserRole:any;
  SocialFeedId:any;
  SocialFeedType:any;
  SocialFeedName:any;
  SocialFeedURL:any
  SocialFeedReamarks:any
  isInvalidSocialFeedType:any;
  isInvalidSocialFeedName:any;
  isInvalidSocialFeedURL:any;
  onDisabledSocialFeeds:any;
  showEditText:boolean = false;
  constructor(private httpService: HttpService, private config: Config, private encryptionService: EncryptionService,
    public dialogRef: MatDialogRef<HomeAddNewSocialFieldPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.SocialFeedId = this.data?.id;
    this.SocialFeedType = this.data?.feedType;
    this.SocialFeedName = this.data?.feedName;
    this.SocialFeedURL = this.data?.feedURL;
    this.SocialFeedReamarks = this.data?.remarks;
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    
    if(this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD'){
      this.onDisabledSocialFeeds = true;
    }else{this.onDisabledSocialFeeds = false}
  }


  // onClickSaveSocialFeed(){
  //   if(this.SocialFeedName == null || this.SocialFeedType == null || this.SocialFeedURL == null){
  //     if(this.SocialFeedName == null){
  //       this.isInvalidSocialFeedName = true;
  //     }else{this.isInvalidSocialFeedName = false}
  //     if(this.SocialFeedType == null){
  //       this.isInvalidSocialFeedType = true
  //     }else{this.isInvalidSocialFeedType = false}
  //     if(this.SocialFeedURL == null){
  //       this.isInvalidSocialFeedURL = true
  //     }else{this.isInvalidSocialFeedURL = false}
  //   }else{
  //     const request = {
  //       "companyId": this.loggedInUserCompanyID,
  //       "id": this.SocialFeedId || null,
  //       "name": this.SocialFeedName,
  //       "remarks": this.SocialFeedReamarks,
  //       "type": this.SocialFeedType,
  //       "url": this.SocialFeedURL || null
  //     } 
  //     console.warn(request);
      
  //     // this.httpService.callPostService(this.config.setSocialFeed, request).subscribe((result:any)=>{
  //     //   this.dialogRef.close();
  //     // })
  //   }
  // }

  onClickSaveSocialFeed() {
    this.isInvalidSocialFeedName = !this.SocialFeedName;
    this.isInvalidSocialFeedType = !this.SocialFeedType;
    this.isInvalidSocialFeedURL = !this.SocialFeedURL;
    if (this.isInvalidSocialFeedName || this.isInvalidSocialFeedType || this.isInvalidSocialFeedURL) {
        return;
    }else{
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "id": this.SocialFeedId || null,
        "name": this.SocialFeedName,
        "remarks": this.SocialFeedReamarks,
        "type": this.SocialFeedType,
        "url": this.SocialFeedURL || null
    };
    this.httpService.callPostService(this.config.setSocialFeed, request).subscribe((result:any) => {
        this.dialogRef.close();
    });
    }
}


  onClickCancelSocialFeed(){
    this.SocialFeedType = '';
    this.SocialFeedName = '';
    this.SocialFeedURL = '';
    this.SocialFeedReamarks = '';
    this.dialogRef.close();
  }
}
 